import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import AsyncSelect from "react-select/lib/Async";
import { NumberField } from "../../../../../../../Utils/renderField/fieldsHookForms";
import { RenderKilogramo } from "../../../../../../../Utils/renderField/renderReadField";
import { useDebouncedAsyncSelect } from "../../../../../../../Utils/Hooks/useDebounce";
import { ESTADOS_ORDEN_PRODUCCION } from "../../../../../../../../../utility/constants";
import { ProduccionV2Api } from "../../../../../api/ProduccionV2Api";
import { formatConsumidorFinalEVS } from "../../../../../helpers/formatValues";
const eliminarIcon = require("assets/img/icons/borrar.png");

export const OrdenesProduccion = (props) => {
    const { ordenesProduccion = [], setOrdenesProduccion } = props;

    const { getEVSProduccion } = ProduccionV2Api();

    const EliminarOrdenProduccion = async (index) => {
        setOrdenesProduccion((prev) => prev.filter((_, i) => i !== index));
    };

    const {
        control: formControl,
        register: formRegister,
        setValue: formSetValue,
        getValues: formGetValues,
        trigger: validateForm,
        watch: watchForm,
        formState: { errors },
    } = useForm({
        mode: "onChange",
    });

    const loadEVS = useDebouncedAsyncSelect(function (search) {
        return getEVSProduccion({ search: search });
    });

    const AgregarOrdenProduccion = async () => {
        const isValid = await validateForm();
        if (!isValid) return;

        const formValues = formGetValues();

        const nuevaOrdenProduccion = {
            ...formValues,
            estado: ESTADOS_ORDEN_PRODUCCION.PENDIENTE,
        };

        // Agregar nueva orden de producción al estado
        setOrdenesProduccion((prev) => [...prev, nuevaOrdenProduccion]);

        // Limpiar campos del formulario
        formSetValue("kg_a_producir", null);
        formSetValue("evs", null);
    };

    const formValues = watchForm();

    return (
        <React.Fragment>
            <div className="d-flex justify-content-between flex-wrap align-items-end mb-3">
                <h4 className="mb-0">Órdenes de producción</h4>
                <div className="formulario-fields-row w-100 gap-1rem flex-wrap">
                    <div className="formulario-field min-w-150">
                        <label className="text-nowrap">EVS</label>
                        <Controller
                            name="evs"
                            control={formControl}
                            rules={{
                                required: "Debe seleccionar un EVS",
                            }}
                            render={({ field }) => (
                                <AsyncSelect
                                    {...field}
                                    className="react-select-container"
                                    isSearchable
                                    isClearable
                                    cacheOptions
                                    defaultOptions
                                    loadOptions={loadEVS}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.numero}
                                    onChange={(selected) => {
                                        field.onChange(selected);
                                    }}
                                />
                            )}
                        />
                        {errors.evs && (
                            <small className="text-danger">
                                {errors.evs.message}
                            </small>
                        )}
                    </div>

                    <div className="formulario-field min-w-150">
                        <label className="text-nowrap">Cliente</label>
                        <input
                            type="text"
                            className="form-control"
                            disabled
                            value={
                                formValues.evs && formValues.evs.cliente
                                    ? formValues.evs.cliente.nombre
                                    : ""
                            }
                        />
                    </div>

                    <div className="formulario-field min-w-150">
                        <label className="text-nowrap">Consumidor final</label>
                        <input
                            type="text"
                            className="form-control"
                            disabled
                            value={formatConsumidorFinalEVS(
                                formValues.evs,
                            )}
                        />
                    </div>

                    <div className="formulario-field min-w-150">
                        <label className="text-nowrap">
                            Producto a producir
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            disabled
                            value={
                                formValues.evs &&
                                formValues.evs.producto_a_producir
                                    ? formValues.evs.producto_a_producir.nombre
                                    : ""
                            }
                        />
                    </div>

                    <div className="formulario-field">
                        <label className="text-nowrap">
                            Kilogramos a producir
                        </label>
                        <NumberField
                            control={formControl}
                            name="kg_a_producir"
                            errors={errors}
                            allowNegative={false}
                            suffix=" Kg"
                            rules={{
                                required: "Este campo es obligatorio",
                                min: {
                                    value: 1,
                                    message: "Debe ser al menos 1",
                                },
                            }}
                            decimalScale={2}
                        />
                    </div>

                    <div
                        className="formulario-field mb-0 ml-auto no-flex"
                        style={{ maxHeight: "57px" }}
                    >
                        <button
                            type="button"
                            className="btn btn-primary mt-auto"
                            onClick={AgregarOrdenProduccion}
                        >
                            Agregar
                        </button>
                    </div>
                </div>
            </div>

            {/* TABLA DE ORDENES DE PRODUCCION */}
            <div className="new-table-wrapper creacion-produccion__table-wrapper">
                <table className="table-striped">
                    <thead>
                        <tr>
                            <th>ACCIONES</th>
                            <th>EVS</th>
                            <th>CLIENTE</th>
                            <th>PRODUCTO A PRODUCIR</th>
                            <th>KG A PRODUCIR</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ordenesProduccion.length === 0 && (
                            <tr>
                                <td className="text-center" colSpan={5}>
                                    No se han agregado órdenes de producción.
                                </td>
                            </tr>
                        )}
                        {ordenesProduccion.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td className="text-center text-nowrap">
                                        <div className="table-actions">
                                            <img
                                                src={eliminarIcon}
                                                alt="Eliminar"
                                                className="action_img"
                                                title="Eliminar"
                                                onClick={() =>
                                                    EliminarOrdenProduccion(
                                                        index,
                                                    )
                                                }
                                            />
                                        </div>
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.evs && item.evs.numero}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.evs &&
                                            item.evs.cliente &&
                                            item.evs.cliente.nombre}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.evs &&
                                            item.evs.producto_a_producir &&
                                            item.evs.producto_a_producir.nombre}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <RenderKilogramo
                                            value={item.kg_a_producir}
                                            decimalScale={2}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </React.Fragment>
    );
};
